import { api } from 'api'
import { createAsyncThunk } from 'modules/store'
import { normalizeApiUrl } from 'packages/helper'
import { downloadBlob } from 'utils/downloadBlob'

export const getAllPromoLogs = createAsyncThunk('promoLogs/getAllPromoLogs', async (_, { rejectWithValue }) =>
  api.promoLogs.getAll().catch((error) => rejectWithValue(error.message)),
)

export const getPromoLogFile = createAsyncThunk(
  'promoLogs/getPromoLogFile',
  async (filename: string, { rejectWithValue }) =>
    api.promoLogs
      .getLink(filename)
      .then((data) => api.promoLogs.download(normalizeApiUrl(data.link)))
      .then((data) => downloadBlob(data, filename))
      .catch((error) => rejectWithValue(error.message)),
)
